/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PatchApiV1PersonIdDeactivateMutationResponse,
  PatchApiV1PersonIdDeactivatePathParams,
  PatchApiV1PersonIdDeactivate401,
  PatchApiV1PersonIdDeactivate404,
  PatchApiV1PersonIdDeactivate500,
} from "../../types/personRegisterController/PatchApiV1PersonIdDeactivate.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { patchApiV1PersonIdDeactivate } from "../../clients/personRegisterController/patchApiV1PersonIdDeactivate.ts";

export const patchApiV1PersonIdDeactivateMutationKey = () =>
  [{ url: "/api/v1/person/:id/deactivate" }] as const;

export type PatchApiV1PersonIdDeactivateMutationKey = ReturnType<
  typeof patchApiV1PersonIdDeactivateMutationKey
>;

export function patchApiV1PersonIdDeactivateMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = patchApiV1PersonIdDeactivateMutationKey();
  return mutationOptions<
    PatchApiV1PersonIdDeactivateMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PersonIdDeactivate401
      | PatchApiV1PersonIdDeactivate404
      | PatchApiV1PersonIdDeactivate500
    >,
    { id: PatchApiV1PersonIdDeactivatePathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return patchApiV1PersonIdDeactivate(id, config);
    },
  });
}

/**
 * @description Desativa uma pessoa (soft delete). **(Requer Authorization para autenticação)**
 * @summary Desativar pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/deactivate}
 */
export function usePatchApiV1PersonIdDeactivate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiV1PersonIdDeactivateMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1PersonIdDeactivate401
        | PatchApiV1PersonIdDeactivate404
        | PatchApiV1PersonIdDeactivate500
      >,
      { id: PatchApiV1PersonIdDeactivatePathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? patchApiV1PersonIdDeactivateMutationKey();

  const baseOptions = patchApiV1PersonIdDeactivateMutationOptions(
    config,
  ) as UseMutationOptions<
    PatchApiV1PersonIdDeactivateMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PersonIdDeactivate401
      | PatchApiV1PersonIdDeactivate404
      | PatchApiV1PersonIdDeactivate500
    >,
    { id: PatchApiV1PersonIdDeactivatePathParams["id"] },
    TContext
  >;

  return useMutation<
    PatchApiV1PersonIdDeactivateMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PersonIdDeactivate401
      | PatchApiV1PersonIdDeactivate404
      | PatchApiV1PersonIdDeactivate500
    >,
    { id: PatchApiV1PersonIdDeactivatePathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiV1PersonIdDeactivateMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PersonIdDeactivate401
      | PatchApiV1PersonIdDeactivate404
      | PatchApiV1PersonIdDeactivate500
    >,
    { id: PatchApiV1PersonIdDeactivatePathParams["id"] },
    TContext
  >;
}
